/* eslint-disable */
import _ from 'underscore';
import { FilterEntity } from '@bingads-webui/filter-entity';
import { odataQuery } from '@bingads-webui/odata-converter';
import { ODataBaseAdaptor } from './js-data-odata-adaptor';

export class ODataAdaptor extends ODataBaseAdaptor {
  convertQuery(queryParameters) {
    const { filterOptions = {}, where = {} } = queryParameters;
    const ret = odataQuery.convert(queryParameters);
    const { '*': { contains: search } = {} } = where;

    if (!_.isString(where) || _.isEmpty(where)) {
      const restWhere = _.omit(where, '*');

      if (!_.isEmpty(restWhere)) {
        const $filter = new FilterEntity(
          restWhere,
          {
            entitySchema: filterOptions.schema.entitySchema,
            odata: {
              fieldMap: filterOptions.fieldMap,
              ignoreCase: filterOptions.ignoreCase,
              custom: filterOptions.custom,
            },
        }).odataV4();
        if (!_.isEmpty($filter)) {
          ret.$filter = $filter;
        }
      }
    }

    return ret;
  }
}
